
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"23","height":"23","viewBox":"0 0 23 23"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_2750","data-name":"Group 2750","transform":"translate(0.5 0.5)"}},[_c('path',{attrs:{"id":"Union_61","data-name":"Union 61","d":"M556,1463.583v-9.793l-6.925,6.925a.5.5,0,0,1-.707-.707l6.924-6.924H545.5a.5.5,0,0,1,0-1h9.571l-6.925-6.926a.5.5,0,0,1,.707-.707L556,1451.6v-10.015a.5.5,0,1,1,1,0v9.792l6.925-6.924a.5.5,0,0,1,.707.707l-6.926,6.926H567.5a.5.5,0,0,1,0,1H557.486l6.924,6.924a.5.5,0,0,1-.707.707l-6.7-6.7v9.571a.5.5,0,1,1-1,0Z","transform":"translate(-545.5 -1441.583)","fill":"#fff"}})])])
          )
        }
      }
    